// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hierarchicalAnalytics-main .hierarchical-level span {
  font-weight: bold;
  font-size: 38px;
  color: #7b7b7b;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin: 3px 0;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item .box {
  height: 16px;
  border: 2px solid #5f52c4;
  margin-right: 3px;
  border-radius: 50rem;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item .box.active {
  background: #5f52c4;
  cursor: default;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item .box.nextLevel {
  background: black;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(1) .box {
  width: 16px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(2) .box {
  width: 32px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(3) .box {
  width: 48px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(4) .box {
  width: 64px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(5) .box {
  width: 80px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(6) .box {
  width: 96px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(7) .box {
  width: 112px;
}
.hierarchicalAnalytics-main .hierarchical-level .content-item:nth-child(8) .box {
  width: 128px;
}
.hierarchicalAnalytics-main .margin-left {
  text-align: left;
  margin-left: 15px;
}
.hierarchicalAnalytics-main .content-nivel {
  display: flex;
  align-items: center;
}
.hierarchicalAnalytics-main .title-nivel {
  font-weight: bold;
  font-size: 18px;
  color: #7b7b7b;
}
.hierarchicalAnalytics-main .body-nivel {
  padding: 30px 50px;
}
.hierarchicalAnalytics-main .informative-body-text {
  padding: 18px 0;
  color: #5f52c4;
}
.hierarchicalAnalytics-main .possible-areas {
  padding: 8px 0;
  color: #40c3fe;
  font-weight: bold;
}
.hierarchicalAnalytics-main .actual-nivel-text {
  font-size: 18px;
  color: #5f52c4;
}
.hierarchicalAnalytics-main .next-nivel-text {
  font-size: 18px;
  color: #40c3fe;
}
.hierarchicalAnalytics-main .align-nivel-title {
  margin-left: 282px;
}`, "",{"version":3,"sources":["webpack://./src/Views/Analytics/Components/HierarchicalLevel/hierarchicalLevel.sass"],"names":[],"mappings":"AAEQ;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AADZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AADZ;AAIY;EACI,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AAFhB;AAIgB;EACI,mBAAA;EACA,eAAA;AAFpB;AAGgB;EACI,iBAAA;AADpB;AAIY;EACI,WAAA;AAFhB;AACY;EACI,WAAA;AAChB;AAFY;EACI,WAAA;AAIhB;AALY;EACI,WAAA;AAOhB;AARY;EACI,WAAA;AAUhB;AAXY;EACI,WAAA;AAahB;AAdY;EACI,YAAA;AAgBhB;AAjBY;EACI,YAAA;AAmBhB;AAjBI;EACI,gBAAA;EACA,iBAAA;AAmBR;AAjBI;EACI,aAAA;EACA,mBAAA;AAmBR;AAjBI;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAmBR;AAjBI;EACI,kBAAA;AAmBR;AAjBI;EACI,eAAA;EACA,cAAA;AAmBR;AAjBI;EACI,cAAA;EACA,cAAA;EACA,iBAAA;AAmBR;AAjBI;EACI,eAAA;EACA,cAAA;AAmBR;AAjBI;EACI,eAAA;EACA,cAAA;AAmBR;AAjBI;EACI,kBAAA;AAmBR","sourcesContent":[".hierarchicalAnalytics-main\n    .hierarchical-level\n        span\n            font-weight: bold\n            font-size: 38px\n            color: #7b7b7b\n\n        .content-item\n            display: flex\n            align-items: center\n            font-size: 12px\n            margin: 3px 0\n            \n        \n            .box\n                height: 16px\n                border: 2px solid #5f52c4\n                margin-right: 3px\n                border-radius: 50rem   \n\n                &.active\n                    background: #5f52c4\n                    cursor: default\n                &.nextLevel\n                    background: black\n\n        @for $i from 1 through 8\n            .content-item:nth-child(#{$i}) .box\n                width: calc(16px * $i)\n\n    .margin-left\n        text-align: left\n        margin-left: 15px\n\n    .content-nivel\n        display: flex\n        align-items: center\n        \n    .title-nivel\n        font-weight: bold\n        font-size: 18px\n        color: #7b7b7b\n\n    .body-nivel\n        padding: 30px 50px\n\n    .informative-body-text\n        padding: 18px 0\n        color: #5f52c4\n\n    .possible-areas\n        padding: 8px 0\n        color: #40c3fe\n        font-weight: bold\n\n    .actual-nivel-text\n        font-size: 18px\n        color: #5f52c4\n\n    .next-nivel-text\n        font-size: 18px\n        color: #40c3fe\n\n    .align-nivel-title\n        margin-left: 282px\n\n\n        "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
